import isMobile from "../isMobile";

$(document).ready(function() {
    const searchElem = $(".search");
    const searchOpen = searchElem.attr("data-open-direction");
    searchElem.find("button[type='submit']").on("click", function(e) {
        e.preventDefault();
        if (searchElem.hasClass("show")) {
            searchElem.trigger("submit");
        }

        searchElem.addClass("show");


        if (searchOpen === "left") {
            searchElem.find("input").css("right", "0px");
        }

        if (searchOpen === "right") {
            searchElem.find("input").css("left", "0px");
        }

        if (isMobile()) {
           searchElem.find("input").css("max-width", `${searchElem.closest(".container").width()}px`);
        }
    });

    $(document).mouseup(function(e) {
        if ($(e.target).parents(".search").length !== 1) {
            searchElem.removeClass("show");
        }
    });
});
